import React, { Component } from 'react';
import * as yup from 'yup';
import { map } from 'lodash';
import Loader from '../../../Common/Component/Loader';
import { errorHandle } from "../../../Common/errorHandle";
// import { formatToCurrency } from "../../../../Tools/formatToCurrency";

import { Select, message } from 'antd';
const { Option } = Select;
class LogPayment extends Component {
  fattJs = null;

  constructor(props) {
    super(props);
    this.state = {
      log_type: '',
      card_list: [],
      payment_log: {
        cash_payment: false,
        cheque_payment: false,
        is_check: false,
        received_from: `${this.props?.crr_user?.user?.first_name} ${this.props?.crr_user?.user?.last_name}`,
        amount_received: '',
        cheque_id: '',
        user_uuid: '',
        received_by_uuid: ''
      },
      errors: {},
      loader: false,
      card_payment_type: 0,
      new_card_uuid: '',
      is_card_payment: false,
      id_old_card: false,
      customerList:[],
      franchise_uuid: '',
      card_number : '',
      card_expiry_month : '',
      card_expiry_year : '',
      card_cvv : '',
      stax_customer_id : '',
      stax_public_apikey: null,
      hideAddNewButton: false,
      card_count:0,
      customer:{},
      ComCustomer:{},
      transaction_type:'create'
    }
  }

  componentDidMount = () => {
    let { payment_log,transaction_type } = this.state;
    let type = transaction_type;
    this.setState({loader: true})
    let authUser = JSON.parse(localStorage.getItem('authUser'));
    if(this.props.crr_user?.service_order?.service_type==='residential'){
      this.props.getCustomerDetail(this.props.crr_user?.user_uuid) // get customer detail
    }else{
      this.props.getCommercialCustomer(this.props.crr_user?.user_uuid) // get customer detail
    }
    const associated_field_offices = authUser?.user?.associated_field_offices?.map(x => x.uuid);
    this.props.getStaffUsers({ staff_profile__field_office__uuid: associated_field_offices?.[0], invoice_list: true });
    payment_log = Object.assign(payment_log, { user_uuid: this.props.crr_user?.user?.uuid, received_by_uuid: authUser?.user?.uuid,received_from: `${this.props?.crr_user?.user?.first_name} ${this.props?.crr_user?.user?.last_name}`,received_by: `${authUser?.user.first_name} ${authUser?.user.last_name}` });
    var selected_payment = this.props.selected_payment
    if (this.props.edit)
    {
      type = 'edit';
      const payment_log_data = {
        cash_payment: selected_payment?.payment_type === "Cash" ? true : false,
        cheque_payment: selected_payment?.payment_type === "Check" ? true : false,
        received_from: selected_payment?.received_from,
        amount_received: selected_payment?.amount_received,
        user_uuid: this.props.crr_user?.user_uuid,
        invoice_uuid: this.props.invoice_uuid,
        is_check: selected_payment?.payment_type === 'Check' ? true : false,
        cheque_id: selected_payment?.check_id,
        uuid: selected_payment.uuid,
        received_by: selected_payment?.received_by?selected_payment?.received_by:`${authUser?.user.first_name} ${authUser?.user.last_name}`,
        received_by_uuid: authUser?.user?.uuid,
        payment_type:selected_payment?.payment_type
      };
      this.setState({
        transaction_type: 'edit',
        payment_log: payment_log_data,
        franchise_uuid: associated_field_offices?.[0],
        log_type: selected_payment?.payment_type === "Cash" ? "cash" : "check",
        loader: false
      });
    }else{
      this.setState({payment_log, franchise_uuid: associated_field_offices?.[0], loader: false});
    }
  }

  UNSAFE_componentWillReceiveProps = (props) => {

    if (Object.keys(props?.CustomerList?.customer).length > 0) { 
      this.setState({ customer: props?.CustomerList?.customer });
    }

    let type = this.state.transaction_type;
    let authUser = JSON.parse(localStorage.getItem('authUser'))
    const associated_field_offices = authUser?.user?.associated_field_offices?.map(x => x.uuid);

    var selected_payment = props.selected_payment
    if (this.props.edit && props.selected_payment!==this.props.selected_payment)
    {
      type = 'edit';
      const payment_log_data = {
        cash_payment: selected_payment?.payment_type === "Cash" ? true : false,
        cheque_payment: selected_payment?.payment_type === "Check" ? true : false,
        received_from: selected_payment?.received_from,
        amount_received: selected_payment?.amount_received,
        user_uuid: props.crr_user?.user_uuid,
        invoice_uuid: props.invoice_uuid,
        is_check: selected_payment?.payment_type === 'Check' ? true : false,
        cheque_id: selected_payment?.check_id,
        uuid: selected_payment.uuid,
        received_by: selected_payment?.received_by?selected_payment?.received_by:`${authUser?.user.first_name} ${authUser?.user.last_name}`,
        received_by_uuid: authUser?.user?.uuid,
        payment_type:selected_payment?.payment_type
      };
      this.setState({
        transaction_type: 'edit',
        payment_log: payment_log_data,
        franchise_uuid: associated_field_offices?.[0],
        log_type: selected_payment?.payment_type === "Cash" ? "cash" : "check",
        loader: false
      });
    }

    // get customer detail
    if (Object.keys(props?.CommercialCustomer?.getCustomer).length > 0) { 
      this.setState({ ComCustomer: props?.CommercialCustomer?.getCustomer });
    }
    
    // get stax customer detail
    if (Object.keys(props.StaxCustomer.data).length === 0) {
      const { crr_user } = this.props;
      if (Object.keys(crr_user).length > 0) {
        this.props.getStaxCustomerDetail(crr_user.user.uuid);
      }
    }

    // set stax customer detail
    if (Object.keys(props.StaxCustomer.data).length > 0) {
      this.setState({
        stax_customer_id:  props?.StaxCustomer?.data?.stax_customer,
        stax_public_apikey: props?.StaxCustomer?.data?.field_office?.stax_public_apikey,
        hideAddNewButton :  props?.StaxCustomer?.data?.field_office?.stax_public_apikey ? false : true
      });
    }

    if (props && props?.PostPaymentLog && Object.keys(props?.PostPaymentLog.data).length > 0 && props.PostPaymentLog.data !== this.props.PostPaymentLog.data) {
      this.setState({loader : false });
      this.closeAndClear();
      this.props.onUpdated(true);
      // this.props.getPaymentHistory({ invoice__uuid: this.props.invoice_uuid, limit: 10, offset: 0 });

    }
    
    if(props?.PostPaymentLog && Object.keys(props?.PostPaymentLog.errors).length > 0 
      && props.PostPaymentLog.errors !== this.props.PostPaymentLog.errors) {
      this.setState({loader : false });
      this.closeAndClear();
      this.props.onUpdated(false);
    }

    //Add payment
    if (Object.keys(props.GetManualy.data).length > 0 && props.GetManualy.data !== this.props.GetManualy.data) {
      this.setState({
        loader: false
      })
      this.closeAndClear()
    }

    if (Object.keys(props.GetManualy.errors).length > 0 && props.GetManualy.errors !== this.props.GetManualy.errors) {
      // message.error('Something went wrong', 10);
      this.setState({
        loader: false
      })
    }
    
    //Get Customer List
    if (Object.keys(props.UserList.data).length > 0 && props.UserList.data !== this.props.UserList.data) {

      this.setState({
        customerList: props?.UserList?.data?.results,
      })
    }

    if (Object.keys(props.UserList.errors).length > 0 && props.UserList.errors !== this.props.UserList.errors) {
      errorHandle(props.UserList.errors)
      this.setState({
        loader: false,
      })
    }

    //Get Cars dlist
    if (Object.keys(props.CardList.data).length > 0 && props.CardList.data !== this.props.CardList.data) {
      if(props?.CardList?.data?.count===0){
        this.setState({
          card_payment_type:0
        })
      }else{
        this.setState({
          card_payment_type:1
        })
      }
      this.setState({
        card_count:props?.CardList?.data?.count,
        card_list: props?.CardList?.data?.results,
      })
    }

    if (Object.keys(props.CardList.errors).length > 0 && props.CardList.errors !== this.props.CardList.errors) {
      this.setState({
        loader: false
      })
    }

    //Add new card
    if (Object.keys(props.AddCard.data).length > 0 && props.AddCard.data !== this.props.AddCard.data) {
      this.setState({
        new_card_uuid: props?.AddCard?.data?.uuid
      }, () => {
        this.addPaymentLog();
      })
    }

    if (Object.keys(props.AddCard.errors).length > 0 && props.AddCard.errors !== this.props.AddCard.errors) {
      this.setState({
        loader: false
      })
    }

    // get staff list
    if (props?.Invoice && Object.keys(props?.Invoice?.staffList).length > 0
      && JSON.stringify(this.props.Invoice?.staffList) !== JSON.stringify(props?.Invoice?.staffList)) {
      this.setState({ staffList: props?.Invoice?.staffList })
    }

    if (this.state.hideAddNewButton) {
      message.error('Error occur while loading stax. please contact to admin.', 500);
    }
  }

  //Payment type change
  onLogTypeChange = (e) => {
    let { payment_log,card_count } = this.state;
    let authUser = JSON.parse(localStorage.getItem('authUser'))

    payment_log = Object.assign(payment_log,
      {
        cash_payment: false,
        cheque_payment: false,
        received_from: `${this.props?.crr_user?.user?.first_name} ${this.props?.crr_user?.user?.last_name}`,
        amount_received: '',
        cheque_id: '',
        received_by_uuid: authUser?.user?.uuid || '',
        is_check: e.target.id === 'check' ? true : false
      }
    )

    this.setState({
      log_type: e.target.id,
      payment_log,
      is_card_payment: false,
      errors: {}
    })
    if (e.target.id === 'card') {
      this.setState({
        id_old_card: true
      })
      if(card_count===0){
        this.setState({
          card_payment_type: 0,
          is_card_payment: true,
          id_old_card: false,
        });
        this.loadStax();
      }
    }
    else {
      this.setState({
        id_old_card: false
      })
    }
  }

  //On Log text change
  onTextChange = (e) => {
    let { payment_log } = this.state;
    payment_log = Object.assign(payment_log, { [e.target.name]: e.target.value });

    this.setState({
      payment_log
    })
  }

  // on search received by
  onSearchReceivedBy = (search) => {
    if (search?.length === 0 || search?.length >= 3) {
      this.props.getStaffUsers({ search: search, staff_profile__field_office__uuid: this.state.franchise_uuid, invoice_list: true })
    }
  }

  //Receive by
  onReceiveChange = (e) => {
    let { payment_log } = this.state;
    payment_log = Object.assign(payment_log, { 'received_by_uuid': e });

    this.setState({
      payment_log
    })
  }

  //Validation
  validateLog = () => {
    let { payment_log, log_type, card_payment_type, is_card_payment, new_card_uuid, id_old_card, card_number, card_expiry_month, card_expiry_year, card_cvv,transaction_type } = this.state;

    if (log_type === 'card' && card_payment_type === 0) {

      const PaymentSchema = yup.object().shape({
        card_number : this.fattJs.validNumber ? null : yup.string().nullable().required('Card Number is required'),
        card_expiry_month : yup.string().nullable().required('Card expire month is required'),
        card_expiry_year : yup.string().nullable().required('Card expire year is required').min(4, 'Card expire year is invalid.').max(4, 'Card expire year is invalid.'),
        card_cvv : this.fattJs.validCvv ? null : yup.string().nullable().required('Card CVC is required'),
        payment_log: yup.object().shape({
          received_from: yup.string().required("Received is required"),
          amount_received: yup.number().required("Amount received is required").typeError('Amount received is required'),
          user_uuid: yup.string().required("User is required"),
          received_by_uuid: yup.string().required("Received by is required"),
          cheque_id: yup.string().when('is_check', {
            is: true,
            then: yup.string().required('Check is required'),
          })
        }),
        is_card_payment: yup.bool(),
        id_old_card: yup.bool(),
        
        new_card_uuid: yup.string().when('id_old_card', {
          is: true,
          then: yup.string().required("Card is required"),
        }),
      });

      const cardData = { payment_log, log_type, is_card_payment, id_old_card, new_card_uuid, card_number, card_expiry_month, card_expiry_year, card_cvv };
      PaymentSchema.validate(cardData, { abortEarly: false }).then(() => {
        this.setState({ errors: {} });
        this.addNewCard();
      }).catch((error) => {
        let err_data = {};
        map(error.inner, (item) => {err_data[item.path] = item.message})
        console.log("Error : ",err_data);
        this.setState({errors: err_data, is_btn_active: false});
        message.error(`Valid ${err_data.card_number}. Valid ${err_data.card_cvv}`);
      });
    } else {
      const PaymentSchema = yup.object().shape({
        payment_log: yup.object().shape({
          received_from: yup.string().required("Received is required"),
          amount_received: yup.number().required("Amount received is required").typeError('Amount received is required'),
          user_uuid: yup.string().required("User is required"),
          received_by_uuid: yup.string().required("Received by is required"),
          cheque_id: yup.string().when('is_check', {
            is: true,
            then: yup.string().required('Check is required'),
          })
        }),
        is_card_payment: yup.bool(),
        id_old_card: yup.bool(),
        new_card_uuid: yup.string().when('id_old_card', {
          is: true,
          then: yup.string().required("Card is required"),
        }),
      });

      const cardData = { payment_log, log_type, is_card_payment, id_old_card, new_card_uuid };
      PaymentSchema.validate(cardData, { abortEarly: false }).then(() => {
        this.setState({ errors: {} });
        if(transaction_type !== 'edit')
        {
          this.addPaymentLog();
        }
        else
        {
          this.updatePaymentLog();
        }
      }).catch((error) => {
        let err_data = {};
        map(error.inner, (item) => {err_data[item.path] = item.message})
        this.setState({errors: err_data, is_btn_active: false});
        message.error(`Valid ${err_data.card_number}. Valid ${err_data.card_cvv}`);
      });
    }
  }

  // Add new card
  addNewCard = () => {
    const { card_expiry_month, card_expiry_year, card_number } = this.state;
    const { crr_user } = this.props;
    this.setState({ loader : true });
    const token_obj = {
      address_1: crr_user ? crr_user.billing_address.address : null,
      address_city: crr_user ? crr_user.billing_address.city : null,
      address_state: crr_user ? crr_user.billing_address.state : null,
      address_zip: crr_user ? crr_user.billing_address.zip_code : null,
      month : card_expiry_month ? card_expiry_month : null,
      year : card_expiry_year ? card_expiry_year : null,
      card_number: card_number ? card_number : null,
      email: crr_user && crr_user.user.email ? crr_user.user.email : null,
      firstname: crr_user && crr_user.user.first_name ? crr_user.user.first_name : null,
      lastname: crr_user && crr_user.user.last_name ? crr_user.user.last_name : null,
      method: 'card',
      person_name: crr_user ? `${crr_user.user.first_name} ${crr_user.user.last_name}` : null,
      phone: this.state.card_phone
    }
    if (this.state.stax_customer_id) {
      token_obj['customer_id'] = this.state.stax_customer_id;
    }
    
    this.fattJs.tokenize(token_obj).then((res) => {
      if (res && Object.keys(res).length > 0) {
        if (!crr_user.billing_address.geo_location) {
          delete crr_user.billing_address.geo_location
        }
        this.props.addNewCard({
          user_uuid: crr_user ? crr_user.user_uuid : null,
          address: crr_user ? crr_user.billing_address : null,
          stax_card_token : res['id'] || null,
          card_holder_name: crr_user ? `${crr_user.user.first_name} ${crr_user.user.last_name}` : null,
        });
      }
    }).catch((err) => {
      this.setState({ loader : false });
      map(err.fieldErrors, (item) => {
        message.error(item.message,10)
      });
      message.error(err.message,10);
    });
  }

  //Add Log Payment Log
  addPaymentLog = () => {
    let { payment_log, log_type, new_card_uuid } = this.state;
    let { received_from, received_by_uuid, user_uuid, amount_received, cheque_id } = payment_log
    let data = {
      cash_payment: log_type === 'cash' ? true : false,
      cheque_payment: log_type === 'check' ? true : false,
      cc_auto_payment: log_type === 'card' ? true : false,
      received_from,
      amount_received: amount_received,
      user_uuid,
      received_by_uuid,
      cheque_id,
      invoice_uuid: this.props.invoice_uuid

    }
    if (log_type === 'cash') {
      delete data.cheque_id

    }
    if (log_type === 'card') {
      delete data.cheque_id
      data.user_billing_info = new_card_uuid
    }
    this.setState({ loader: true })
    this.props.addManualPayment(data)
  }

  updatePaymentLog = () => {
    let { payment_log, log_type, new_card_uuid } = this.state;
    let { received_from, received_by_uuid, user_uuid, amount_received, cheque_id, invoice_uuid, uuid } = payment_log;

    this.setState({ loader : true });

    let data = {
      cash_payment: log_type === 'cash' ? true : false,
      cheque_payment: log_type === 'check' ? true : false,
      cc_auto_payment: log_type === 'card' ? true : false,
      received_from,
      amount_received: parseFloat(amount_received).toFixed(2),
      user_uuid,
      uuid,
      received_by_uuid,
      cheque_id,
      invoice_uuid
    }
    if (log_type === 'cash') {
      delete data.cheque_id;
      delete data.user_billing_info;
    }
    if (log_type === 'check') {
      delete data.user_billing_info;
    }
    if (log_type === 'card') {
      delete data.cheque_id
      data.user_billing_info = new_card_uuid;
    }

    this.props.postPaymentLog(data);
  }

  //Close drawer and clear value
  closeAndClear = () => {
    let { payment_log } = this.state;
    this.props.clearKey()
    this.props.logPaymentToggle(false);

    payment_log = Object.assign(payment_log,
      {
        cash_payment: false,
        cheque_payment: false,
        received_from: '',
        amount_received: '',
        cheque_id: '',
        received_by_uuid: '',
        is_check: false
      }
    )
    this.setState({
      payment_log,
      log_type: '',
      errors: {},
      card_payment_type: 1,
      new_card_uuid: '',
      is_card_payment: false,
      id_old_card: false
    })
  }

  // Load Stax
  loadStax = () => {
    const { stax_public_apikey } = this.state;
    if (stax_public_apikey) {
      const FattJs = window.FattJs;
      const fattJs = new FattJs(stax_public_apikey, {
        number: {
          id: "card-number",
          placeholder: "Card Number",
          style: "height: 35px; width: 100%; font-size: 15px; font-family: Helvetica Neue, Helvetica; color: #31325f; font-weight: 300;"
        },
        cvv: {
          id: "card-cvv",
          placeholder: "CVV",
          style: "height: 35px; width: 100%; font-size: 15px; font-family: Helvetica Neue, Helvetica; color: #31325f; font-weight: 300;"
        }
      });
      fattJs.showCardForm().then(handler => {
        console.log('form loaded', handler);
      }).catch(err => {
        console.error('error occur', err);
      });
      this.fattJs = fattJs;
    } else {
      message.error('Error occur while loading stax. please contact to admin.', 10);
    }
  }

  render() {
    let { log_type, payment_log, loader, errors, card_list, card_payment_type, new_card_uuid, staffList, transaction_type } = this.state;
    return (
      <div className="rdrawer log_payment_drawer">
        <div className="card-row">
          <div className="card-full">
            <h4>{`${ transaction_type === 'create' ? 'Log Manual Payment' : 'Edit Payment'}`}</h4>

            {/* Cash payment */}
            {(transaction_type !== 'edit' || payment_log.payment_type === "Cash")?
              <div className={log_type === 'cash' ? 'form-group  log_card  mb-20' : 'form-group'}>
                <div className="fitem">
                  <div className="fitem-check">
                    <input
                      type="radio"
                      className="fitem-ck-input"
                      id="cash"
                      checked={log_type === 'cash'}
                      onChange={(e) => { this.onLogTypeChange(e) }}
                      name="cash" />
                    <label htmlFor="cash" className="fitem-ck-txt">Cash Payment</label>
                  </div>
                </div>
                {log_type === 'cash' ?
                  <div>
                    <div className="fitem text_with_place amount">
                      <label>Amount Received</label>
                      <div style={{"position": "relative"}}>
                        <input type="text"
                          className="twhite"
                          name="amount_received"
                          value={payment_log.amount_received}
                          onChange={(e) => { this.onTextChange(e) }}
                          inputMode="numeric"
                          max='6'
                          maxLength='6'
                          onPaste={(event) => {
                            if (event.clipboardData.getData('Text').match(/[^\d]/)) {
                              event.preventDefault();
                            }
                          }}
                          onKeyUp={(e) => {
                            var keyCode = (e.which) ? e.which : e.keyCode;
                            if ((keyCode >= 48 && keyCode <= 57) || (keyCode === 8))
                              return true;
                            else if (keyCode === 46) {
                              var curVal = document.activeElement.value;
                              if (curVal !== null && curVal.trim().indexOf('.') === -1)
                                return true;
                              else
                                return false;
                            }
                            else
                              return false;
                          }}
                          placeholder="0.00"
                        />
                      </div>
                      {errors['payment_log.amount_received'] ? <label className="new_err_msg"><i className="las la-info-circle"></i>{errors['payment_log.amount_received']}</label> : ''}
                      {payment_log.amount_received ? <div className="fix_isd_code t-25"><span>$</span></div> : ''}
                    </div>
                    <div className="fitem">
                      <label>Received From</label>
                      <input type="text"
                        className="twhite"
                        name="received_from"
                        value={payment_log.received_from}
                        onChange={(e) => { this.onTextChange(e) }}
                        placeholder="" />
                      {errors['payment_log.received_from'] ? <label className="new_err_msg"><i className="las la-info-circle"></i>{errors['payment_log.received_from']}</label> : ''}
                    </div>
                    <div className="fitem">
                      <label>Received By</label>
                      <Select
                        showSearch
                        filterOption={false}
                        value={payment_log.received_by_uuid}
                        onChange={(e) => { this.onReceiveChange(e) }}
                        onSearch={(e) => this.onSearchReceivedBy(e)}
                        onBlur={() => this.onSearchReceivedBy()}
                        defaultValue=""
                        className="swhite">
                        <Option value={payment_log?.received_by_uuid}>
                          {payment_log?.received_by}
                        </Option>
                        {/* {map(staffList?.results, (item) => {
                        return (
                          <Option key={item.uuid}>{item.first_name} {item.last_name}</Option>
                        )
                      })} */}

                      </Select>
                      {errors['payment_log.received_by_uuid'] ? <label className="new_err_msg"><i className="las la-info-circle"></i>{errors['payment_log.received_by_uuid']}</label> : ''}
                    </div>
                  </div>
                  : ''}

              </div>:null}

            {/* Check Payment */}
            {(transaction_type !== 'edit' || payment_log.payment_type === "Check")?
              <div className={log_type === 'check' ? 'form-group  log_card' : 'form-group'}>
                <div className="fitem">
                  <div className="fitem-check">
                    <input
                      type="radio"
                      className="fitem-ck-input"
                      id="check"
                      checked={log_type === 'check'}
                      onChange={(e) => { this.onLogTypeChange(e) }}
                      name="check" />
                    <label htmlFor="check" className="fitem-ck-txt">Check Payment</label>
                  </div>
                </div>
                {log_type === 'check' ?
                  <div className="p-30">
                    <div className="fitem text_with_place amount">
                      <label>Amount Received</label>
                      <div style={{"position": "relative"}}>
                        <input 
                          type="text"
                          className="twhite"
                          inputMode="numeric"
                          name="amount_received"
                          value={payment_log.amount_received}
                          onChange={(e) => { this.onTextChange(e) }}
                          onPaste={(event) => {
                            if (event.clipboardData.getData('Text').match(/[^\d]/)) {
                              event.preventDefault();
                            }
                          }}
                          onKeyUp={(e) => {
                            var keyCode = (e.which) ? e.which : e.keyCode;
                            if ((keyCode >= 48 && keyCode <= 57) || (keyCode === 8))
                              return true;
                            else if (keyCode === 46) {
                              var curVal = document.activeElement.value;
                              if (curVal !== null && curVal.trim().indexOf('.') === -1)
                                return true;
                              else
                                return false;
                            }
                            else
                              return false;
                          }}
                          placeholder="0.00"
                        />
                      </div>
                      {errors['payment_log.amount_received'] ? <label className="new_err_msg"><i className="las la-info-circle"></i>{errors['payment_log.amount_received']}</label> : ''}
                      {payment_log.amount_received ? <div className="fix_isd_code t-25"><span>$</span></div> : ''}
                    </div>
                    <div className="fitem">
                      <label>Received From</label>
                      <input type="text"
                        className="twhite"
                        name="received_from"
                        value={payment_log.received_from}
                        onChange={(e) => { this.onTextChange(e) }}
                        placeholder="" />
                      {errors['payment_log.received_from'] ? <label className="new_err_msg"><i className="las la-info-circle"></i>{errors['payment_log.received_from']}</label> : ''}
                    </div>
                    <div className="fitem">
                      <label>Check ID #</label>
                      <input type="text"
                        className="twhite"
                        name="cheque_id"
                        value={payment_log.cheque_id}
                        onChange={(e) => { this.onTextChange(e) }}
                        onPaste={(event) => {
                          if (event.clipboardData.getData('Text').match(/[^\d]/)) {
                            event.preventDefault();
                          }
                        }}
                        onKeyPress={(e) => {
                          const pattern = /[0-9]/;
                          const inputChar = String.fromCharCode(e.charCode);
                          if (!pattern.test(inputChar)
                          ) {
                          // invalid character, prevent input
                            e.preventDefault();
                          }
                        }}
                        placeholder="" />
                      {errors['payment_log.cheque_id'] ? <label className="new_err_msg"><i className="las la-info-circle"></i>{errors['payment_log.cheque_id']}</label> : ''}
                    </div>
                    <div className="fitem">
                      <label>Received By</label>
                      <Select
                        showSearch
                        filterOption={false}
                        value={payment_log.received_by_uuid}
                        onChange={(e) => { this.onReceiveChange(e) }}
                        onSearch={(e) => this.onSearchReceivedBy(e)}
                        onBlur={() => this.onSearchReceivedBy()}
                        defaultValue=""
                        className="swhite">
                        <Option value={payment_log?.received_by_uuid}>
                          {payment_log?.received_by}
                        </Option>
                        {/* {map(staffList?.results, (item) => {
                        return (
                          <Option key={item.uuid}>{item.first_name} {item.last_name}</Option>
                        )
                      })} */}

                      </Select>
                      {errors['payment_log.received_from'] ? <label className="new_err_msg"><i className="las la-info-circle"></i>{errors['payment_log.received_from']}</label> : ''}
                    </div>
                  </div>
                  : ''}

              </div>:null}

            {/* Card Payment */}
            {transaction_type !== 'edit'?
              <div className={log_type === 'card' ? 'form-group  log_card' : 'form-group'}>
                <div className="fitem">
                  <div className="fitem-check">
                    <input
                      type="radio"
                      className="fitem-ck-input"
                      id="card"
                      checked={log_type === 'card'}
                      onChange={(e) => { this.onLogTypeChange(e) }}
                      name="card" />
                    <label htmlFor="card" className="fitem-ck-txt">Card Payment</label>
                  </div>
                </div>

                {log_type === 'card' ?
                  <div className="p-30">
                    <div className="fitem text_with_place amount">
                      <label>Amount Received</label>
                      <div style={{"position": "relative"}}>
                        <input type="text"
                          className="twhite"
                          inputMode="numeric"
                          name="amount_received"
                          value={payment_log.amount_received}
                          onChange={(e) => { this.onTextChange(e) }}
                          onPaste={(event) => {
                            if (event.clipboardData.getData('Text').match(/[^\d]/)) {
                              event.preventDefault();
                            }
                          }}
                          onKeyUp={(e) => {
                            var keyCode = (e.which) ? e.which : e.keyCode;
                            if ((keyCode >= 48 && keyCode <= 57) || (keyCode === 8))
                              return true;
                            else if (keyCode === 46) {
                              var curVal = document.activeElement.value;
                              if (curVal !== null && curVal.trim().indexOf('.') === -1)
                                return true;
                              else
                                return false;
                            }
                            else
                              return false;
                          }}
                          placeholder="0.00"
                        />
                      </div>
                      {errors['payment_log.amount_received'] ? <label className="new_err_msg"><i className="las la-info-circle"></i>{errors['payment_log.amount_received']}</label> : ''}
                      {payment_log.amount_received ? <div className="fix_isd_code t-25"><span>$</span></div> : ''}
                    </div>
                    <div className="fitem">
                      <label>Received From</label>
                      <input type="text"
                        className="twhite"
                        name="received_from"
                        value={payment_log.received_from}
                        onChange={(e) => { this.onTextChange(e) }}
                        placeholder="" />
                      {errors['payment_log.received_from'] ? <label className="new_err_msg"><i className="las la-info-circle"></i>{errors['payment_log.received_from']}</label> : ''}
                    </div>

                    <div className="fitem half-fitem">
                      <div className="fitem half-fitem inline-check-list">
                        <div className="fitem-check">
                          <input
                            type="radio"
                            className="fitem-ck-input"
                            id="new_card"
                            checked={card_payment_type === 0}
                            onChange={() => {
                              this.setState({
                                card_payment_type: 0,
                                is_card_payment: true,
                                id_old_card: false
                              });
                              this.loadStax();
                            }}
                            name="card_type" />
                          <label htmlFor="new_card" className="fitem-ck-txt">Add New Card</label>
                        </div>
                      </div>

                      <div className="fitem half-fitem inline-check-list">
                        <div className="fitem-check">
                          <input
                            type="radio"
                            className="fitem-ck-input"
                            id="old_card"
                            checked={card_payment_type === 1}
                            onChange={() => {
                              this.setState({
                                card_payment_type: 1,
                                is_card_payment: false,
                                id_old_card: true
                              })
                            }}
                            name="card_type" />
                          <label htmlFor="old_card" className="fitem-ck-txt">Use Existing Card</label>
                        </div>
                      </div>
                    </div>
                    {card_payment_type === 1 ?
                      <div className="fitem">
                        <label>Card List</label>
                        <Select
                          placeholder="Select Card"
                          filterOption={false}
                          value={new_card_uuid}
                          onChange={(e) => {
                            this.setState({
                              new_card_uuid: e
                            })
                          }}
                          className="swhite">
                          {map(card_list, (item) => {
                            return (
                              <Option key={item.uuid}>{item?.card_holder_name}-{JSON.parse(item?.stax_payment_object)?.card_last_four}</Option>
                            )
                          })}

                        </Select>
                        {errors['new_card_uuid'] ? <label className="new_err_msg"><i className="las la-info-circle"></i>{errors['new_card_uuid']}</label> : ''}
                      </div>
                      :
                      <React.Fragment>
                        <div className="fitem">
                          <label>Card Number</label>
                          <div id="card-number" className="form--control twhite"></div>
                        </div>
                        <div className="fitem">
                          <label>CVV</label>
                          <div id="card-cvv" className="form--control twhite"></div>
                        </div>
                        <div className="fitem half-fitem">
                          <div className="fitem half-fitem">
                            <label>Expiration Month</label>
                            <input type="text" className="form--control twhite" placeholder="MM" maxLength={2} 
                              inputMode="numeric"
                              onPaste={(event) => {
                                if (event.clipboardData.getData('Text').match(/[^\d]/)) {
                                  event.preventDefault();
                                }
                              }}
                              onKeyPress={(e) => {
                                const pattern = /[0-9]/;
                                const inputChar = String.fromCharCode(e.charCode);
                                if (!pattern.test(inputChar)
                                ) {
                                  // invalid character, prevent input
                                  e.preventDefault();
                                }
                              }}
                              onChange={(e) => { this.setState({ card_expiry_month: e.target.value }) }} />
                            {errors?.['card_expiry_month'] ? <label className="new_err_msg"><i className="las la-info-circle"/>{errors?.['card_expiry_month']}</label> : ''}
                          </div>
                          <div className="fitem half-fitem">
                            <label>Expiration Year</label>
                            <input type="text" className="form--control twhite" placeholder="YYYY" maxLength={4} 
                              inputMode="numeric"
                              onPaste={(event) => {
                                if (event.clipboardData.getData('Text').match(/[^\d]/)) {
                                  event.preventDefault();
                                }
                              }}
                              onKeyPress={(e) => {
                                const pattern = /[0-9]/;
                                const inputChar = String.fromCharCode(e.charCode);
                                if (!pattern.test(inputChar)
                                ) {
                                // invalid character, prevent input
                                  e.preventDefault();
                                }
                              }}
                              onChange={(e) => { this.setState({ card_expiry_year: e.target.value }) }} 
                            />
                            {errors?.['card_expiry_year'] ? <label className="new_err_msg"><i className="las la-info-circle"/>{errors?.['card_expiry_year']}</label> : ''}
                          </div>
                        </div>
                      </React.Fragment>
                    }
                    <div className="fitem">
                      <label>Received By</label>
                      <Select
                        showSearch
                        filterOption={false}
                        value={payment_log.received_by_uuid}
                        onChange={(e) => { this.onReceiveChange(e) }}
                        onSearch={(e) => this.onSearchReceivedBy(e)}
                        onBlur={() => this.onSearchReceivedBy()}
                        defaultValue=""
                        className="swhite">
                        <Option value={payment_log?.received_by_uuid}>
                          {payment_log?.received_by}
                        </Option>
                        {/* {map(staffList?.results, (item) => {
                        return (
                          <Option key={item.uuid}>{item.first_name} {item.last_name}</Option>
                        )
                      })} */}

                      </Select>
                      {errors['payment_log.received_by_uuid'] ? <label className="new_err_msg"><i className="las la-info-circle"></i>{errors['payment_log.received_by_uuid']}</label> : ''}
                    </div>
                  </div>
                  : ''}
              </div>:null}
          </div>

          <div className="footer" style={{ 'width': '420px' }}>
            <button
              className="btn btn-brand btn-bdr"
              onClick={() => {
                this.closeAndClear()
              }}
            >Cancel</button>
            <button
              className='btn btn-warning'
              onClick={() => { this.validateLog() }}

            >{ transaction_type === 'create' ? 'Log Payment' : 'Update Payment'}</button>
          </div>
        </div>
        {loader ? <Loader /> : ''}
      </div>
    );
  }
}

export default LogPayment;